import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  track({ params }) {
    if (!this.hasUrlValue || !params.event) return

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    window.fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {})
      },
      body: JSON.stringify({ event_name: params.event, screen: params.screen }),
      credentials: "same-origin",
      keepalive: true
    }).catch(() => {})
  }
}
